<template>
  <div class="background-primary" >
    <div class="footer">
      <div class="box">
        <a href="/">
          <img 
            :src="require('../assets/logo_cuseremp_dark.svg')" 
            style="height:40px;"
          >
        </a>
      </div>
      <div class="box box-central">
        © CUSEREMP {{new Date().getFullYear()}}  |  Desarrollado por <a href="https://moxdata.com" target="_blank" class="brand"> MOXDATA SAC</a> 
      </div>
      <div class="box">
        <ul class="uk-navbar-nav">
          <li v-for="item in social" :key="item.icon">
            <a 
              :uk-icon="item.icon"
              :href="item.link"
              target="_blank"
            >
            </a>
          </li>
        </ul>
      </div>
      
        
      
    </div>
  </div>
</template>

<script >
export default {
  data() {
    return {
      social: [
        {
          icon: 'linkedin',
          link: 'https://www.linkedin.com/company/cuseremp/'
        },
        {
          icon: 'facebook',
          link: 'https://www.facebook.com/CUSEREMP'
        },
        {
          icon: 'instagram',
          link: 'https://www.instagram.com/cuseremp_sac/?hl=es-la'
        }
      ],
      menu: {},
      class: null
    };
  },
}
</script>

<style scoped>
  .background-primary {
    background: #ff4949ff;
    width: 100%;
  }
  .ma-2{
    margin: 20px;
  }
  .uk-navbar-nav>li>a:hover {
    color: rgb(255, 255, 255)!important;
  }
  .brand {
    margin-left: 5px;
  }
  .footer{
    width: 90vw;
    display: flex;
    /* flex-direction: row; */
    justify-content: space-between;
    /* flex-wrap: wrap; */
    margin: auto;
  }
  .box{
    /* width: 25%; */
    height: 50px;
    margin: 20px;
    color: #fff;
  }

  .box>a{
    color: #fff;
  }

  @media screen and (max-width: 600px){
    .footer{
      flex-direction: column;
      justify-content: center;
    }
  }
</style>